import ApiService from '../../services/api.service';
import EventModel from '../event/event-model';
import JournalgroupModel from '../journalgroup/journalgroup-model';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerModel from '../owner/owner-model';
import ProducttypeModel from '../producttype/producttype-model';
import ScheduleModel from '../schedule/schedule-model';

export default class ProductModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    producttype: any;
    producttypeCaption: string;
    producttypeType: string;
    unit: string;
    qty: number;
    qtymin: number;
    qtymax: number;
    pricebase: number;
    pricesale: number;
    margin: number;
    totalamount: number;
    image: any;
    imageId: number;
    imageUrl: string;    
    product: any;
    productLength: number;
    productCaption: string;
    amounttype: any;
    amounttypeLength: number;
    amounttypeCaption: string;
    journalgroup: any;
    journalgroupCaption: string;
    event: any;
    eventCaption: string;
    eventAstemplate: string;
    schedule: any;
    scheduleLength: number;
    scheduleCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        let producttype = datarow.producttype?.data? new ProducttypeModel(datarow.producttype?.data) : datarow.producttype;
        this.producttype = producttype?.id;
        this.producttypeCaption = producttype?.name;
        this.producttypeType = producttype?.type;
        this.unit = datarow.unit || '';
        this.qty = datarow.qty || 0;
        this.qtymin = datarow.qtymin || 0;
        this.qtymax = datarow.qtymax || 0;
        this.pricebase = datarow.pricebase || 0;
        this.pricesale = datarow.pricesale || 0;
        this.margin = datarow.margin || 0;
        this.totalamount = datarow.totalamount || 0;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        this.product = datarow.product?.data?.map((d: any) => new ProductModel(d));
        this.productLength = this.product?.length;
        this.productCaption = this.productLength===0? '' : this.product?.[0]?.name + (this.productLength>1? ', ...': '');  
        this.amounttype = datarow.amounttype?.data?.map((d: any) => new ProductModel(d));
        this.amounttypeLength = this.amounttype?.length || 0;
        this.amounttypeCaption = this.amounttype?.length===0? '' : this.amounttype?.[0]?.name + (this.amounttype?.length>1? ', ...': '');  
        let journalgroup = datarow.journalgroup?.data? new JournalgroupModel(datarow.journalgroup?.data) : datarow.journalgroup;
        this.journalgroup = journalgroup?.id;
        this.journalgroupCaption = journalgroup?.name;
        let event = datarow.event?.data? new EventModel(datarow.event?.data) : datarow.event;
        this.event = event?.id;
        this.eventCaption = event?.name;
        this.eventAstemplate = event?.astemplate;
        this.schedule = datarow.schedule?.data?.map((d: any) => new ScheduleModel(d));
        this.scheduleLength = this.schedule?.length;
        this.scheduleCaption = this.scheduleLength===0? '' : this.schedule?.[0]?.name + (this.scheduleLength>1? ', ...': '');  
        
    } 

    public static endPoint: string = 'products' 
    public static endPointMedia: string = 'api::product.product';
    public static endPointFilter = (parentId?: number, producttypeType?: string, productgroupId?: number, status?: string) => {
       const owner = OwnerModel.getOwner();
       return ( '?populate=*&sort=name&filters[owner]=' + owner + (parentId? '&filters[parent]=' + parentId : '') + (producttypeType? '&filters[producttype][type]=' + producttypeType : '') + (productgroupId? '&filters[productgroup]=' + productgroupId : '') + (status? '&filters[status]=' + status : ''));
    } 
    public static url: string = '/product';
    public static caption: string = 'Product';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),         
        producttype: null,
        producttypeCaption: '',
        producttypeType: '',
        unit: '',
        qty: 0,
        qtymin: 0,
        qtymax: 0,
        pricebase: 0,
        pricesale: 0,
        margin: 0,
        totalamount: 0,
        image: null,
        imageId: 0,
        imageUrl: '',
        product: [],
        productLength: 0,
        productCaption: '',   
        amounttype: [],
        amounttypeLength: 0,
        amounttypeCaption: '',
        journalgroup: null,
        journalgroupCaption: '',
        event: null,
        eventCaption: '',
        eventAstemplate: 'no',
        schedule: [],
        scheduleLength: 0,
        scheduleCaption: '',  
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'pricebase', caption: 'Price Base', type: 'money' },
        { name: 'pricesale', caption: 'Price Sale', type: 'money' },
        { name: 'qty', caption: 'Qty', type: 'number' },
    ]

    public static columnPicklistCard = [
        { name: 'imageUrl', type: 'media' },
        { name: 'name', type: 'caption' },
        { name: 'description'},
        { name: 'pricebase', type: 'money', hideNull: true },
        { name: 'pricesale', type: 'money', hideNull: true },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}